<template>
    <b-button 
        v-if="$temAcessoView('DESP-GERAIS-REQ-04') && permiteComprometer"
        class="ml-2"
        variant="success"
        @click.stop="confirmarComprometer()"
    >
        <span>
            {{tituloBotao}}
        </span>
    </b-button>
</template>

<script>
import DespesasServicos from './DespesasServicos'
import { StatusComprometimento } from '../../componentes/despesas/StatusComprometimento'
import { StatusDespesa } from '../../componentes/despesas/StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => null
        }
    },  

    methods: {
        confirmarComprometer() {
            this.$swal({
                title: 'Despesa',
                html: `Confirma o comprometimento da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.comprometer()
                }
            })
        },

        comprometer() {
            this.$store.dispatch('addRequest')
            DespesasServicos.comprometer(this.despesa.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa comprometida com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$emit("exibirErro", response.errors[0])
                    }
                    this.$emit('obterDespesa')
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        permiteComprometer() {
            return this.despesa != null
                && this.statusPermiteComprometer
                && this.despesa.itensDespesas.length != 0
                && this.itensRateados
                && this.despesa.solicitanteDespesa
        },

        statusPermiteComprometer() {
            return this.despesa.statusComprometimentoId != StatusComprometimento.COMPROMETIDO
                && this.despesa.statusId != StatusDespesa.APROVADA
                && this.despesa.statusId != StatusDespesa.CANCELADA
        },

        itensRateados() {
            return this.despesa.itensDespesas.every(p => {
                return p.rateios.length > 0
            })
        },

        tituloBotao() {
            if (this.despesa.statusComprometimentoId == StatusComprometimento.ATUALIZAR_COMPROMETIMENTO
                || (this.despesa.idMov != null 
                    && this.despesa.statusComprometimentoId == StatusComprometimento.ERRO)
            ) {
                return 'Atualizar Comprometimento'
            }
            return 'Comprometer'
        }
    }
}

</script>